'use client'

import React from 'react'
import ReactPaginate from 'react-paginate'
import { usePathname, useRouter } from 'next/navigation'

import { convertSerachParamsToURLSearchParams } from 'app/utils/urls'

import { StyledPagination } from './styles'

type Props = {
  pageCount: number
  pageRangeDisplayed?: number
  marginPagesDisplayed?: number
  currentPage: number

  queryParams: {
    [key: string]: string | string[] | undefined
  }

  startTransition: (cb: () => void) => void
}

const Pagination = ({
  pageCount,
  pageRangeDisplayed = 3,
  marginPagesDisplayed = 3,
  currentPage,
  queryParams,
  startTransition,
}: Props): JSX.Element => {
  const pathname = usePathname()
  const router = useRouter()

  const onPageChange = (selectedItem: { selected: number }) => {
    const page = selectedItem.selected + 1
    queryParams.page = page.toString()
    const params = convertSerachParamsToURLSearchParams(queryParams)

    startTransition(() => {
      router.push(`${pathname}?${params.toString()}`)
    })

    window.scrollTo(0, 0)
  }

  return (
    <StyledPagination data-testid="pagination">
      <ReactPaginate
        onPageChange={onPageChange}
        pageCount={pageCount}
        pageRangeDisplayed={pageRangeDisplayed}
        marginPagesDisplayed={marginPagesDisplayed}
        initialPage={currentPage - 1}
        containerClassName="pagination_container"
        pageClassName="pagination_page"
        activeClassName="pagination_active"
        forcePage={currentPage - 1}
        disableInitialCallback={true}
      />
    </StyledPagination>
  )
}

export default Pagination
